<template>
  <div v-if="stripecancelshow" class="payment-dialog">
      <h2>Cancel Subscriptions</h2>
      <p>These are subscriptions for your users.  To cancel your subscription please go to the Account & Billing Section</p><br>

      <div v-if="!updating && !verifying" style="overflow-y: auto;">
        <center>
          <table v-if="lineitemlist.length>0" style="width:80%;border-collapse: collapse;">
            <tr v-for="s in lineitemlist">
                <td style="font-weight:bold;padding:6px;font-size:20px;width:45%;">
                  {{ standardpriceset.find(item => item.priceid === s.pricename).desc }}
                </td>
                <td style="font-weight:bold;padding:6px;font-size:16px;">
                  <button class="cancelbutton" @click="SetSelectedSub(s.subid,s.pricename)">Cancel Subscription</button>
                </td>
            </tr>
          </table>
          <div v-if="lineitemlist.length === 0" class="verifyingclass">
            <p>You currently don't have any added Subscriptions</p>
          </div>
        </center>
      </div>
      <div v-if="!updating && verifying" class="verifyingclass">
        <p>Are you sure that you want to Cancel the Subscription?</p>
        <button class="yesbutton" @click="CancelSub(currentselectedsub,currentselectedprice)">Yes</button>
        <button class="nobutton" @click="AbortCancel()">No</button>
      </div>
      <div v-if="updating && !verifying"  class="messages">
        {{ message }}
      </div>
      <br>
      <div class="btns">
        <btn v-if="!updating" class="button secondary" v-text="'Close'" @click="Cancel()"></btn>
      </div>
  </div>
</template>
  
<script setup>
  import { ref, watch } from 'vue';
  import btn from '../buttons/button.vue';
  import { useStore } from 'vuex';
  const props = defineProps({stripecancelshow: Boolean});
  const emit = defineEmits(['close']);
  const updating = ref(false);
  const verifying = ref(false);
  const currentselectedsub = ref();
  const currentselectedprice = ref();
  const message = ref("Please wait while we gather your Subscriptions...");
  const store = useStore();
  let user = ref(store.state.user);
  const standardpriceset = ref([])
  const lineitemlist = ref([])

  watch(
      () => props.stripecancelshow, (newValue, oldValue) => {
        console.log("stripecancelshow changed")
        GetCurrentSubscriptions();
  })
  
  function Cancel() {
      emit("close");
  }

  function AbortCancel() {
    verifying.value = false;
    currentselectedsub.value = "";
    currentselectedprice.value = "";
  }

  function SetSelectedSub(subid,price) {
    verifying.value = true;
    currentselectedsub.value = subid;
    currentselectedprice.value = price;

  }

  function CancelSub(subid,price) {
    verifying.value = false;
    message.value = "Please wait while we Cancel this Subscription..."
    updating.value = true;
    fetch("https://api.bopus.ai/api/payCancelSubscription.php", {
        headers: {'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify({
            "subid": subid,
            "price": price
        })
    }).then((res) => res.json()).then((response) => {
        console.log(response);
        verifying.value = false;
        updating.value = false;
        GetCurrentSubscriptions();
    }).catch((error) => {
        console.log('Looks like there was a problem cancelling subscription: \n', error);
        verifying.value = false;
        updating.value = false;
        GetCurrentSubscriptions();
    });
  }

  function GetCurrentSubscriptions() {
      message.value = "Please wait while we gather your Subscriptions..."
      updating.value = true;
      fetch("https://api.bopus.ai/api/payGetCustomerSubs.php", {
          headers: {'Content-type': 'application/json'},
          method: 'POST',
          body: JSON.stringify({
              "customeremail": user.value.email
          })
      }).then((res) => res.json()).then((response) => {
          console.log(response);
          standardpriceset.value = response.standardpriceset;
          lineitemlist.value = response.lineitemlist;
          verifying.value = false;
          updating.value = false;
      }).catch((error) => {
          console.log('Looks like there was a problem retrieving subscriptions: \n', error);
          verifying.value = false;
          updating.value = false;
      });
  }
  GetCurrentSubscriptions();
</script>
  
<style lang="scss" scoped>
.yesbutton {
  padding:12px;
  font-size:20px;
  border-radius:10px;
  border:none;
  background-color: rgb(0, 145, 5);
  color:white;
  cursor: pointer;
  margin:5px;
}
.nobutton {
  padding:12px;
  font-size:20px;
  border-radius:10px;
  border:none;
  background-color: rgb(145, 7, 0);
  color:white;
  cursor: pointer;
  margin:5px;
}
.cancelbutton {
  padding:12px;
  font-size:20px;
  border-radius:10px;
  border:none;
  background-color: red;
  color:white;
  cursor: pointer;
}
.dummybutton {
    border:1px #888 solid;
    border-radius:8px;
    color:#888;
    font-size: 26px;
    padding-top:4px;
}
.portalbutton {
    border:1px #888 solid;
    border-radius:8px;
    background-color: bisque;
    color:#888;
    font-size: 20px;
    padding:14px;
    cursor: pointer;
}
.no-double-select {
  -webkit-user-select: none;
  user-select: none;
  pointer-events: none; /* Prevents mouse events */
}
.addbtn {
    width:50px;
    height:50px;
    font-size:28px;
    font-weight: bold;
    -webkit-user-select: auto;
    user-select: auto;
    border-color: #ccc;
    border-radius: 10px;
}
.addnum {
    font-size:24px;
    font-weight:bold;
    padding:10px;
}
.messages {
    text-align: center;
    font-weight: bold;
    padding:20px;
    border-radius: 10px;
    background-color:rgb(255, 251, 126);
}
.verifyingclass {
    text-align: center;
    font-weight: bold;
    padding:20px;
    border-radius: 10px;
    background-color:rgb(248, 245, 245);
}
.payment-dialog {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.45);
  width: calc(100% - 32px);
  max-width: 840px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 32px 32px 145px;
  border-radius: 16px;
  background-color: #fff;
  z-index: 3;
  box-sizing: border-box;
  border:1px #333 solid;
  h3{
    margin: 0 0 32px 0;
  }
  p{
    margin: 0 auto;
    color: #787878
  }
  .btns{
    text-align: center;
    position: absolute;
    bottom: 32px;
    width: 100%;
    left: 0px;
    display: flex;
    padding: 0 32px;
    box-sizing: border-box;
    .button{
      padding: 0;
    }
    :first-child{
      width: 125px;
      margin-right: 16px;
    }
    :last-child{
      flex: 1;
    }
  }
}
@media screen and (max-width: 599px) and (orientation: portrait),
screen and (max-height: 500px) and (orientation: landscape) {
  .disabled_warning{
    padding: 16px 16px 115px;
  }
}
</style>